module.exports = __webpack_public_path__ + "static/media/money.a7eeb12a.svg";